<template>
  <div class="form-container">
    <div class="header">
      <h1 :class="[{ 'sport-organization-title': isSportOrganization() }]">Registriraj se</h1>
      <v-icon
        style="cursor: pointer; user-select: none"
        :style="isSportOrganization() && 'color: white'"
        @click="$emit('close')"
      >
        close
      </v-icon>
    </div>
    <div style="width: 100%">
      <text-field v-model="form.firstName" :validator="$v.form.firstName" label="Ime*" />
      <text-field v-model="form.lastName" :validator="$v.form.lastName" label="Prezime*" />
      <text-field
        v-model.trim="form.email"
        :validator="$v.form.email"
        type="email"
        label="Unesi email*"
      />
      <text-field
        v-model.trim="form.password"
        :validator="$v.form.password"
        type="password"
        label="Unesi lozinku od najmanje 8 znakova*"
      />
    </div>
    <div class="lower-container">
      <div class="user-account">
        <p class="have-account" :style="isSportOrganization() && 'color: white'">Već imaš račun?</p>
        <button
          type="button"
          class="login-button"
          :style="isSportOrganization() && 'color: white; border-bottom-color: white'"
          @click="$emit('openLoginModal')"
        >
          Prijavi se
        </button>
      </div>
      <main-button
        :style="isSportOrganization() ? 'color: #0054A5' : 'border-radius: 0'"
        :color="isSportOrganization() ? 'white' : '#333'"
        @click="handleSubmit"
      >
        Izradi korisnički račun
      </main-button>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { submitGuard } from '@/utils'
import { OrganizationType } from '@/types'

export default {
  name: 'sign-in-modal-form',
  props: {
    organizationType: String,
  },
  validations() {
    return {
      form: {
        email: { required, email },
        password: { required },
        firstName: { required },
        lastName: { required },
      },
    }
  },
  data() {
    return {
      form: {},
    }
  },
  methods: {
    async handleSubmit() {
      await submitGuard(this, async () => {
        this.$emit('submit', this.form)
      })
    },
    isSportOrganization() {
      return this.organizationType === OrganizationType.SPORT_ORGANIZATION
    },
  },
}
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  width: 100%;
}
.have-account {
  color: #333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
  letter-spacing: 0.24px;
}
.login-button {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 19.2px */
  letter-spacing: 0.24px;
  border-bottom: 0.5px solid #333;
}
.user-account {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
p {
  margin-bottom: 0;
}
h1 {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 24px;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 28.8px */
  letter-spacing: -0.72px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
@media screen and (max-width: 650px) {
  .lower-container {
    flex-direction: column-reverse;
    gap: 2rem;
  }
}
.lower-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.sport-organization-title {
  color: #fff;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.72px;
}
</style>
